exports.en = {
  CSPS_MILLION_CHILD: {
    DATE_BIRTH_LABEL: 'Datum narození dítěte:',
    DATE_START_LABEL: 'Datum kdy mu začnete spořit:',
    MONTHLY_SAVINGS: 'Měsíčně budete spořit:',
    CONTRIBUTION: 'Měsíčně vám přispěje zaměstnavatel:',
    INIT_DEPOSIT: 'Jednorázově vložíte:',
    ANNUAL_YIELD: 'Předpokládané roční zhodnocení:',
    ANNUAL_YIELD_TOOLTIP: '1% pro Konzervativní fond, 4% pro Vyvážený fond, 6% pro Dynamický fond',
    TOTAL_EXPECTED_SAVINGS: 'Celková výše naspořených prostředků v 18 letech:',
    EIGHTEEN_WITHDRAWAL: 'Výše prostředků, které lze v 18 letech vybrat:',
    PARTICIPANT_CONTRIBUTION: 'Celkové příspěvky účastníka:',
    EMPLOYER_CONTRIBUTION: 'Celkové příspěvky zaměstnavatele:',
    STATE_CONTRIBUTION: 'Celkové státní příspěvky:',
    EXTRA_INCOME: 'Celkové výnosy:',
    ORDER_ONLINE: 'Arrange online',
    ORDER_ONLINE_MESSAGE: 'From the comfort of home. Just a few clicks away.',
    CALL_ME: 'Get in touch with me',
    CALL_ME_MESSAGE: 'We’d love to hear your voice. Leave your number and we’ll get in touch.',
    HINT: {
      LABEL: 'TIP',
      TEXT: 'Pro výběr částečného odbytného je potřeba splnit minimálně 120 měsíců spoření.'
    }
  },
  CZK: 'CZK',
  PLURAL: {
    YEARS: 'year |||| years'
  },
  MONTH_NAMES: {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December'
  }
}
